import moment from 'moment';

// We're using custom Offsets so to avoid unintended values, we will be using UTC Time
const DateCellRenderer = ({ value: date }) =>
	moment.isDate(date) ? moment(date).format('MM/DD/YYYY') : '';

export default DateCellRenderer;
